
import {
  Vue, Component, PropSync, Prop, Watch,
} from 'vue-property-decorator';
import { PrintLabelSize } from '@/features/shipment/types';
import EmailDocs from './EmailDocs.vue';

@Component({
  components: {
    EmailDocs,
  },
})
export default class PrintLabel extends Vue {
  @PropSync('enlarge', { required: false, default: false }) enlargeSync!: boolean;

  @PropSync('isQRCodeMode', { required: false, default: false }) isQRCodeModeSync!: boolean;

  @Prop({ required: true }) secureshipTrackingNo!: string;

  @Prop({ default: true }) minimumPackagingAgree!: boolean;

  @PropSync('labelSize', { required: true }) labelSizeSync!: keyof typeof PrintLabelSize;

  @PropSync('showEmailDocs', { required: false, default: false }) showEmailDocsSync!: boolean;

  @Prop({ required: true }) pdfSrc!: string;

  @Prop({ required: false, default: false }) isLabelFree!: boolean;

  @Prop({ required: false, default: false }) isLabelFreeBoxFree!: boolean;

  private cachedPdfs: { [key: string]: string } = {};

  private currentCacheKey = '';

  get iframeSrc(): string {
    if (!this.minimumPackagingAgree || !this.pdfSrc) {
      return '';
    }

    return this.pdfSrc ? `${this.pdfSrc}#pagemode=none&statusbar=1&messages=0&navpanes=0&toolbar=0` : '';
  }

  private getCacheKey = (labelSize: keyof typeof PrintLabelSize, qrMode: boolean) => {
    if (qrMode) return 'label-free-qr';
    return `${labelSize}-pdf`;
  }

  private async cacheCurrentPdf() {
    if (!this.iframeSrc) return;

    const cacheKey = this.getCacheKey(this.labelSizeSync, this.isQRCodeModeSync);
    this.cachedPdfs = { ...this.cachedPdfs, [cacheKey]: this.iframeSrc };
    this.currentCacheKey = cacheKey;
  }

  private async printLabel(documentSize: keyof typeof PrintLabelSize) {
    this.isQRCodeModeSync = false;
    this.labelSizeSync = documentSize;

    const cacheKey = this.getCacheKey(documentSize, false);

    if (this.cachedPdfs[cacheKey]) {
      this.currentCacheKey = cacheKey;
      return;
    }

    this.$emit('print');
  }

  private handleQRCodeMode() {
    this.isQRCodeModeSync = true;

    const cacheKey = this.getCacheKey(this.labelSizeSync, true);

    if (this.cachedPdfs[cacheKey]) {
      this.currentCacheKey = cacheKey;
      return;
    }

    this.$emit('print');
  }

  beforeDestroy() {
    this.cachedPdfs = {};
  }

  @Watch('pdfSrc', { immediate: true })
  private async onPdfSrcChange() {
    if (!this.pdfSrc) return;
    await this.$nextTick();
    this.cacheCurrentPdf();
  }
}
